<template>
  <div>
    Время приема {{ message.visit_time }}<br>
    Пациент
    <button v-on:click="onClick" type="button">
      <router-link class="server-message__link" v-bind:to="navigateToPatient">
        {{ message.patient_name }}
      </router-link>
    </button>
    пришел на прием<br>
  </div>
</template>

<script>

/**
 * @description Название события пациент пришел на прием.
 * @type {String}
 */
export const EVENT_PATIENT_CAME = 'patient-came';

/**
 * @typedef {Object} Message Сообщение.
 * @property {Number} patient_id
 * @property {String} patient_name
 * @property {Number} visit_id
 * @property {String} visit_time
 */

/**
 * @description Компонент серверного сообщения пациент пришел на прием.
 */
export default {
  computed: {
    navigateToPatient() {
      return {
        name: 'ClinicPanelPatientVisit',
        params: { id: this.message.patient_id, visitId: this.message.visit_id },
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('hide');
    },
  },
  name: 'ServerMessagePatientCame',
  props: {
    message: { required: true, type: Object },
  },
};
</script>
